import type { MiniAppBridge, PlatformId } from './types';
import { createTelegramBridge, getTelegramWebApp } from './telegram';
import { createMaxBridge, getMaxWebApp } from './max';
import { createWebBridge } from './web';
import { detectLaunchPlatform } from './shared';

export * from './types';

let cached: MiniAppBridge | null = null;

function forcedPlatform(): PlatformId | null {
  const fromEnv = import.meta.env.VITE_PLATFORM as PlatformId | undefined;
  const fromQuery = new URLSearchParams(window.location.search).get('platform') as PlatformId | null;
  const value = fromQuery ?? fromEnv;
  return value === 'telegram' || value === 'max' || value === 'web' ? value : null;
}

/**
 * Определение платформы и создание моста.
 *
 * Порядок: явное переопределение (env или ?platform=) → объект мессенджера на
 * странице → данные запуска в адресе → веб. Результат кэшируется: мост живёт
 * всё время работы приложения.
 *
 * Адрес нужен как источник, потому что MAX не выставляет своего объекта: без
 * него приложение считало себя открытым в браузере и отправляло на сервер
 * чужую платформу, из-за чего подпись проверялась не тем ключом.
 */
export function getBridge(): MiniAppBridge {
  if (cached) return cached;

  const forced = forcedPlatform();
  const maxApp = getMaxWebApp();
  const telegramApp = getTelegramWebApp();
  const launched = detectLaunchPlatform();

  if (forced === 'web') cached = createWebBridge();
  else if (forced === 'max' && maxApp) cached = createMaxBridge(maxApp);
  else if (forced === 'telegram' && telegramApp) cached = createTelegramBridge(telegramApp);
  else if (maxApp) cached = createMaxBridge(maxApp);
  else if (telegramApp && telegramApp.initData) cached = createTelegramBridge(telegramApp);
  else if (launched === 'max') {
    // Объекта у MAX нет, но данные запуска его выдают: возможности моста
    // ограничены, зато платформа и подпись уходят на сервер верные
    cached = createMaxBridge({});
  } else if (telegramApp && telegramApp.platform && telegramApp.platform !== 'unknown') {
    cached = createTelegramBridge(telegramApp);
  } else cached = createWebBridge();

  return cached;
}
